import create from "zustand";
import { persist } from "zustand/middleware";

export type UserModelType = {
  id: string;
  username: string;
  name: string;
  lastName: string;
  emailAddress: string;
  startDate: number;
  endDate: number;
  jobId: number;
  reportTypeId: number;
  companyName: string;
  completedTutorial: boolean;
  affiliateId: string;
  profilePhotoBase64?: string | null;
};

export interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: UserModelType | null;
  setAccessToken: (token: string | null) => void;
  setRefreshToken: (token: string | null) => void;
  setUser: (user: UserModelType | null) => void;
  logout: () => void;
}

const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      setAccessToken: (token) => set({ accessToken: token }),
      setRefreshToken: (token) => set({ refreshToken: token }),
      setUser: (user) => set({ user: user }),
      logout: () => {
        localStorage.clear();
        set({ accessToken: null, refreshToken: null, user: null });
        window.location.href = "/login";
      },
    }),
    {
      name: "auth-storage", // unique name for localStorage key
      getStorage: () => localStorage, // specify localStorage as the storage provider
    }
  )
);

export default useAuthStore;
